import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router";

const UnsavedChangesModal = ({
  showConfirmModal,
  setShowConfirmModal,
  hasUnsavedChanges,
  confirmNavigation,
  nextRoute,
}) => {
  const navigate = useNavigate();

  const handleLeave = () => {
    confirmNavigation(() => {
      navigate(nextRoute);
    });
  };

  return (
    <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} >
      <Modal.Header  className="license-title" closeButton>
        <Modal.Title className="text-white roboto-regular">Save Changes</Modal.Title>
      </Modal.Header>
      <Modal.Body  className="text-center">
        <p className="text-center pt-3 roboto-regular">
          There are unsaved changes. Do you want to proceed without saving?
          </p>
<div className="text-center mt-2 pt-3">
         <button className="license-delete-btn-yes mx-2" onClick={handleLeave}>
          Yes
        </button>
        <button  className="license-delete-btn" onClick={() => setShowConfirmModal(false)}>
          No
        </button>

</div>
</Modal.Body>

    </Modal>
  );
};

export default UnsavedChangesModal;
